import { SKILL_LEARNING_LEVEL_COUNT } from '../../../options/skill-learning.option';
import {
  SpecializationFormData,
  SpecializationFormInitialValue,
  SpecializationFormOptions,
} from '../../../models/skill-learning.model';

export const SPECIALIZATION_FORM_MESSAGE = {
  DEFAULT_SUBMIT_LABEL: 'SKILL_LEARNING_ADMIN_FORM_SAVE',
  CREATE_SUBMIT_LABEL: 'SKILL_LEARNING_ADMIN_CREATE_SUBMIT',
  CURATOR_WARNING: 'SKILL_LEARNING_ADMIN_FORM_FILL_ASSIGNEE_REQUIRED',
  CURATOR_REQUIRED_WARNING: 'SKILL_LEARNING_ADMIN_FORM_CURATOR_REQUIRED',
  DEFAULT_CURATOR_LABEL: 'SKILL_LEARNING_ADMIN_FORM_CURATORS_LABEL',
  DEFAULT_HEAD_BADGE: 'SKILL_LEARNING_ADMIN_DEFAULT_HEAD_CURATOR_BADGE',
};

export const SPECIALIZATION_FORM_CONTROL = {
  NAME: 'name',
  DESCRIPTION: 'description',
  GROUP_ID: 'groupId',
  FILL_ASSIGNEE_ID: 'fillAssigneeId',
  CURATOR_IDS: 'curatorIds',
  CURATORS: 'curators',
  RESPONSIBLE_GROUP_ID: 'responsibleGroupId',
  CROSS_DEPARTMENTAL: 'crossDepartmental',
  PARTICIPANT_GROUP_IDS: 'participantGroupIds',
  RESPONSIBLE_GROUP_BY_DEPARTMENT_ID: 'responsibleGroupByDepartmentId',
};

export const SPECIALIZATION_FORM_ACCEPTED_LEVEL = {
  MIN: SKILL_LEARNING_LEVEL_COUNT.TWO,
  MAX: SKILL_LEARNING_LEVEL_COUNT.THREE,
};

export const SPECIALIZATION_FORM_SELECTION = {
  MIN_PARTICIPANT_GROUPS: SKILL_LEARNING_LEVEL_COUNT.TWO,
  EMPTY_COUNT: 0,
  NOT_FOUND_INDEX: -1,
  EMPTY_VALUE: '',
};

export const SPECIALIZATION_FORM_FORMAT = {
  PERSON_NAME_SEPARATOR: ' ',
};

export const SPECIALIZATION_CURATOR_SOURCE = {
  HEAD_DEFAULT: 'HEAD_DEFAULT',
};

export const SPECIALIZATION_CURATOR_SELECTION = {
  EMPTY_COUNT: 0,
  NOT_FOUND_INDEX: -1,
  SINGLE_GROUP_COUNT: 1,
  UNLIMITED: 0,
};

export const DEFAULT_SPECIALIZATION_FORM_INITIAL_VALUE: SpecializationFormInitialValue = {
  name: SPECIALIZATION_FORM_SELECTION.EMPTY_VALUE,
  description: SPECIALIZATION_FORM_SELECTION.EMPTY_VALUE,
  groupId: SPECIALIZATION_FORM_SELECTION.EMPTY_VALUE,
  curatorIds: [],
  curators: [],
  fillAssigneeId: SPECIALIZATION_FORM_SELECTION.EMPTY_VALUE,
  crossDepartmental: false,
  participantGroupIds: [],
  responsibleGroupByDepartmentId: {},
  responsibleGroupId: SPECIALIZATION_FORM_SELECTION.EMPTY_VALUE,
};

export const DEFAULT_SPECIALIZATION_FORM_DATA: SpecializationFormData = {
  manageableCuratorGroupIds: [],
  availableGroups: [],
  availableCurators: [],
  availableFillAssignees: [],
};

export const DEFAULT_SPECIALIZATION_FORM_OPTIONS: SpecializationFormOptions = {
  showGroupSelector: false,
  showCurators: false,
  showFillAssigneeSelector: false,
  showCrossDepartmentalOption: false,
  showCrossDepartmentCurators: false,
  responsibleGroupsLocked: false,
  isSubmitting: false,
  submitLabel: SPECIALIZATION_FORM_MESSAGE.DEFAULT_SUBMIT_LABEL,
  requireCurator: false,
  requireFillAssignee: false,
  maxCurators: SPECIALIZATION_CURATOR_SELECTION.UNLIMITED,
  showFillAssigneeHint: false,
  curatorLabelKey: SPECIALIZATION_FORM_MESSAGE.DEFAULT_CURATOR_LABEL,
  canAssignAnyCuratorLevel: false,
  configuredLevelCount: SKILL_LEARNING_LEVEL_COUNT.ONE,
  contentEditable: true,
};



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/components/admin/specialization-form/specialization-form.option.ts